class FtcVariantSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const card = /** @type {HTMLElement | null} */ (event.target)?.closest('.ftc-variant-selector__card');
      if (!(card instanceof HTMLElement)) return;
      if (card.getAttribute('aria-checked') === 'true') return;

      const { variantId } = card.dataset;
      if (!variantId) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.location.href = url.toString();
    });
  }
}

if (!customElements.get('ftc-variant-selector')) {
  customElements.define('ftc-variant-selector', FtcVariantSelector);
}
